import { render, staticRenderFns } from "./RoteirizacaoAlocacaoEditor.vue?vue&type=template&id=0882bef2&scoped=true&"
import script from "./RoteirizacaoAlocacaoEditor.vue?vue&type=script&lang=js&"
export * from "./RoteirizacaoAlocacaoEditor.vue?vue&type=script&lang=js&"
import style0 from "./RoteirizacaoAlocacaoEditor.vue?vue&type=style&index=0&id=0882bef2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882bef2",
  null
  
)

export default component.exports